// extracted by mini-css-extract-plugin
export default {"root":"EncounterDatePicker_root__Q1mNB","encDatePicker":"EncounterDatePicker_encDatePicker__3pk4b","calendarIcon":"EncounterDatePicker_calendarIcon__c885x"};